<template>
  <vx-card no-shadow v-if="showWindow">
    <vs-popup classContent="popup-example" title="Update bank" :active.sync="popupUpdateWallet">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Address" v-model="params.address" disabled/>
        </div>
      </div>   
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Status</label>
          <select v-model="params.status"  class="form-control inputx w-full" label="Status">
            <option>declined</option>
            <option>approved</option>
          </select>
        </div>
      </div>   
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Comment" v-model="params.comment" />
        </div>
      </div>      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('update-wallet')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-table max-items="5" pagination :data="tableData">
            <template slot="thead">
                <vs-th>address</vs-th>
                <vs-th>created_at</vs-th>
                <vs-th>currency</vs-th>
                <vs-th>full_name</vs-th>
                <vs-th>last_updated</vs-th>
                <vs-th>user_id</vs-th>
                <vs-th>username</vs-th>
                <vs-th>ver_status</vs-th>
                <vs-th>verification_type</vs-th>
                <vs-th>wallet_id</vs-th>
                <vs-th>action</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td :data="data[indextr].address">
                        {{data[indextr].address}}
                    </vs-td>
                    <vs-td :data="data[indextr].created_at">
                        {{data[indextr].created_at}}
                    </vs-td>
                    <vs-td :data="data[indextr].currency">
                        {{data[indextr].currency}}
                    </vs-td>
                    <vs-td :data="data[indextr].full_name">
                        {{data[indextr].full_name}}
                    </vs-td>
                    <vs-td :data="data[indextr].last_updated">
                        {{data[indextr].last_updated}}
                    </vs-td>
                    <vs-td :data="data[indextr].user_id">
                        {{data[indextr].user_id}}
                    </vs-td>
                    <vs-td :data="data[indextr].username">
                        {{data[indextr].username}}
                    </vs-td>
                    <vs-td :data="data[indextr].ver_status">
                        {{data[indextr].ver_status}}
                    </vs-td>
                    <vs-td :data="data[indextr].verification_type">
                        {{data[indextr].verification_type}}
                    </vs-td>
                    <vs-td :data="data[indextr].wallet_id">
                        {{data[indextr].wallet_id}}
                    </vs-td>
                    <vs-td :data="data[indextr].action">
                        <vs-button @click="showUpdateWallet(data[indextr])" color="primary" type="filled">Update</vs-button>              
                    </vs-td>
                    <template  slot="expand">
                      <div class="vx-row w-full">
                        <div class="vx-col w-1/3">
                          <vs-input class="inputx w-full" label="Name" :value="details.first_name+' '+details.last_name"/>
                        </div>
                        <div class="vx-col w-1/3">
                          <vs-input class="inputx w-full" label="Address" :value="details.address+', '+details.city+' '+details.state+' '+details.Country+' '+details.postal"/>
                        </div>
                        <div class="vx-col w-1/3" v-if="data[indextr].doc!==undefined">
                          <br />
                          <a href='javascript:void(0)' @click="showDoc(data[indextr].doc)">Show doc</a>
                        </div>
                      </div>
                  </template>
                </vs-tr>
            </template>
        </vs-table>
  </vx-card>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import saleStatus from '../../../resources/sale_status.json';
export default {
  data() {
    return {
      details:{},
      popupSend: false,
      popupBankDetails: false,
      popupActive: false,
      params: {},
      originalParams:{},
      saleStatus:saleStatus,
      tableData:[],
      popupUpdateBank:false,
      companies: []
    }
  },
  components:{
    'v-select': vSelect,
  },
  computed: {
    showWindow(){
      if(this.$route.path.indexOf('/clients/')!==-1){
        //if(this.fieldsData.length===0)
          this.setData();
        return true;
      }
      return false;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods:{
    showUpdateWallet(data){
      this.params = {};
      for(let i in data){
        this.$set(this.params,i,data[i]);
        this.$set(this.originalParams,i,data[i]);        
      }
      this.popupUpdateWallet = true;
    },    
    sendData: function(type){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', type);
      params.append('email', this.$route.params.email);
        params.append('comment', this.params.comment!==undefined ? this.params.comment : '');
        params.append('status', this.params.status!==undefined ? this.params.status : '');
        params.append('address', this.params.address!==undefined ? this.params.address : '');
        params.append('method', 'update_wallet');      
      this.$vs.loading();
      axios.post("/api/client",params)
      .then((data) => {
        that.setData(true);
        that.$vs.loading.close();
        if(data.data[0].out1==='done!'){
          that.openAlert('success','Success',data.data[0].out1);
          that.reset();
        } else{
          that.openAlert('danger','Failed',data.data[0].out1);
        }
      })
      .catch((data) => { that.$vs.loading.close();  that.openAlert('danger','Failed',data.data[0].out1); })
    },
    reset: function(){
      this.popupActive= false;
      this.params= {};
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    setData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'get-wallets');
      params.append('email', this.$route.params.email);
      axios.post("/api/client",params)
      .then((response) => {
        that.tableData.splice(0);
        for(let i in response.data){
          let data = JSON.parse(response.data[i].object);
          that.tableData.push(data);
        }
      })
      this.getCompanies();  
    },
    getCompanies: function(){
      const params = new URLSearchParams();
      params.append('type', 'get-companies');
      params.append('email', this.$route.params.email);
      let that = this;      
      axios.post("/api/client",params)
      .then((response) => {
        that.companies.splice(0);
        for(let i in response.data){
          let company = JSON.parse(response.data[i].object);          
          that.companies.push({company_name:company.company_name})
        }
      })
    }
  }
}
</script>
